import * as React from 'react';
import GET_CANCELLATION_REASON from 'coaching/queries/GetCancellationReasons.gql';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';
import {
  GetCancellationReasons,
  GetCancellationReasons_coaching_getCancellationReasons_reasons,
} from 'coaching/queries/__generated__/GetCancellationReasons';

export type Props = {
  children: (props: {
    cancellationReasons: string[];
    updatedCancellationReasons: GetCancellationReasons_coaching_getCancellationReasons_reasons[];
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
  sessionType?: 'recurringSchedule' | 'instance';
};

export default function GetCancellationReasonsContainer(props: Props) {
  return (
    <Query<GetCancellationReasons>
      query={GET_CANCELLATION_REASON}
      variables={{ sessionType: props.sessionType }}>
      {({ loading, error, data }) => {
        return props.children({
          cancellationReasons: data?.coaching?.getCancellationReasons?.cancellationReasons ?? [],
          updatedCancellationReasons: data?.coaching?.getCancellationReasons?.reasons ?? [],
          loading,
          error,
        });
      }}
    </Query>
  );
}
